// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ReminderTab_wrapper__3o3hb {\n  padding: 28px 32px; }\n  .ReminderTab_wrapper__3o3hb:not(.ReminderTab_noData__3acP1) {\n    background: #f8fcff; }\n\n.ReminderTab_content__1g7Jw {\n  margin-top: 28px;\n  padding: 34px 38px; }\n\n.ReminderTab_remindersList__1Y67m > *:not(:last-child) {\n  margin-bottom: 24px; }\n\n.ReminderTab_loading__2JnPW {\n  margin-left: calc(50% - 10px); }\n\n.ReminderTab_notFound__FV4kD {\n  margin-top: 80px; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "ReminderTab_wrapper__3o3hb",
	"noData": "ReminderTab_noData__3acP1",
	"content": "ReminderTab_content__1g7Jw",
	"remindersList": "ReminderTab_remindersList__1Y67m",
	"loading": "ReminderTab_loading__2JnPW",
	"notFound": "ReminderTab_notFound__FV4kD"
};
module.exports = exports;
